import {Toolbar, ToolbarGroup} from "material-ui";
import {ZzFlatButton} from "../../../core/components/buttons/buttons";
import {loc} from "../../../core/common/config/locales";
import React from "react";
import {action} from "mobx";
import uiService from "../../../core/common/service/uiService";
import sbToolParamsService from "../../service/paramsService";
import SbToolProjectVersionService from "../../service/projectVersionService";
import {observer} from "mobx-react";

interface Props {
  isValueChanged: boolean
  handleChangeValueState: (bool: boolean) => void
}
@observer
export default class ProjectVersionParamsToolbar extends React.Component<Props, any> {

  @action private onSave = () => {
    let newCriteriaVersionName = sbToolParamsService.criterionVersionName;
    if (!newCriteriaVersionName || newCriteriaVersionName.trim().length === 0
      || newCriteriaVersionName === sbToolParamsService.selectedCriterionVersion.name) {
      newCriteriaVersionName = null;
    }
    uiService.showToolbarActionFlag();
    let criterion = sbToolParamsService.selectedCriterion;
    let projectVersion = SbToolProjectVersionService.projectVersion;
    let criterionVersion = sbToolParamsService.selectedCriterionVersion
    let params = sbToolParamsService.paramsValues.peek();
    console.warn("Saving params for criterion : " + criterion.code);
    SbToolProjectVersionService.saveProjectVersionValues(projectVersion.versionId, criterion.criterionId, criterionVersion.versionId, newCriteriaVersionName, params).then(() => {
      console.warn("Saving params success");
      sbToolParamsService.loadResults();
      sbToolParamsService.loadCriterionVersions();
      uiService.hideToolbarActionFlag()
      this.props.handleChangeValueState(false)
    }).catch(error => {
      console.error(error);
    });

  }

  private linkEndGeneratingByBuildingType() {
    const buildingType = SbToolProjectVersionService.projectVersion.project.buildingType.value
    switch (buildingType) {
      case 1: {
        return "bd-vk-1/";
      }
      case 2: {
        return "rd-vk-1/"
      }
      case 3: {
        return "edu-vk-1/"
      }
      case 4: {
        return "ab-vk-1/"
      }
      case 5: {
        return "uni-vk-1/"
      }
      default : {
        break;
      }
    }
  }

  render() {
    let criterion = sbToolParamsService.selectedCriterion;
    let {isValueChanged} = this.props
    return (
      <Toolbar style={{top: 40, zIndex: 1, left: 5, right: 5, marginTop: 3, minHeight: 40}}>
        <ToolbarGroup firstChild>
          <div style={{
            paddingLeft: 10,
            textTransform: "uppercase",
          }}>
            <a href={criterion.link + this.linkEndGeneratingByBuildingType()} target='_blank'
               style={{
                 fontSize: "1.5rem",
                 color: "#000",
                 textDecoration: 'none'
               }}>
              {criterion.type}.{criterion.code} {criterion.name}</a>
          </div>
        </ToolbarGroup>
        <ToolbarGroup lastChild>
          <ZzFlatButton label={loc.i18n`Save Criterion`} onClick={this.onSave}
                        disabled={!isValueChanged}
                        style={{backgroundColor: 'PaleGreen'}}/>
        </ToolbarGroup>
      </Toolbar>
    );
  }
}



// WEBPACK FOOTER //
// ./src/sbtool/component/parameter/projectVersionParamsToolbar.tsx